import { useMemo } from 'react';
import { useMarketZoneListQuery } from '../market/queries';

export const useMarketOptions = ({ includeOther = false }, { enabled = true } = {}) => {
    const { data: marketZones } = useMarketZoneListQuery({ enabled });

    return useMemo(() => {
        if (!marketZones) return [];

        const marketZoneOptions = Object.keys(marketZones)
            .sort()
            .map(market => ({
                text: market.toUpperCase(),
                value: market,
            }));

        if (includeOther) {
            marketZoneOptions.unshift({ text: 'Without Market', value: 'null' });
        }

        return marketZoneOptions;
    }, [marketZones, includeOther]);
};
